
<div class="generic-modal-root" >

  <span *ngIf="submitted"class="row" class="sync-text">Deploying...</span>
  <div *ngIf="!submitted" class="row-padding">

    <div class="row">
      <form
        *ngIf="form"
        [formGroup]="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
        <div class="form-group m-form__group row remove-margin">
          <div class="col-lg-12">
            <app-file-upload
              multiple="false"
              (filesSet)="fileChange($event)"
              [text]="apkFile ? 'File Selected' : 'Choose File'"
              accept=".apk"
            ></app-file-upload>
          </div>
        </div>

        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Version </label>
          <div class="col-lg-8" style="display: flex; flex-direction: row;">
            <input
              type="text"
              (change)="versionChanged()"
              class="form-control m-input"
              formControlName="versionMajor"
            />
            <span style="margin-top: 15px;">.</span>
            <input
              type="text"
              (change)="versionChanged()"
              class="form-control m-input"
              formControlName="versionMinor"
            />
            <span style="margin-top: 15px;">.</span>
            <input
              type="text"
              (change)="versionChanged()"
              class="form-control m-input"
              formControlName="versionPoint"
            />
          </div>
        </div>

        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Description </label>
          <div class="col-lg-8">
              <textarea
                rows="12"
                type="text"
                class="form-control m-input"
                formControlName="description"
            ></textarea>
          </div>
        </div>

        <div class="form-group m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Force Update </label>
          <div class="col-lg-8">
            <input
              type="checkbox"
              class="form-control m-input"
              [checked]="form.controls.forceUpdate.value"
              formControlName="forceUpdate"
            />
          </div>
        </div>

        <div class="form-group m-form__group row remove-margin" >
          <div class="col-lg-12">
            <span *ngIf="hasFormError" style="color: red; ">Please complete the required fields</span>
          </div>
        </div>

        <div style="height: 45px;">
          <button
            (click)="close()"
            class="btn btn-success"
            style="margin:10px; float:right"
          >
            Cancel
          </button>
          <button
            (click)="save()"
            class="btn btn-success"
            style="margin-top:10px; float:right"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div> 